export default {
  title: 'Zapisz dane kontaktowe i płatnicze',
  form: {
    remember_me: {
      label: 'Utwórz konto, aby szybciej składać kolejne zamówienia.',
    },
  },
};
